var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.923 6.46173C16.7187 5.83567 16.1612 5.43114 15.5027 5.43114H11.256L9.9187 1.36996C9.71314 0.745662 9.15679 0.343262 8.50016 0.343262C8.49973 0.343262 6.50781 7.09492 6.50781 7.09492L8.49973 13.8466L11.9466 16.3638C12.4798 16.7532 13.1698 16.7544 13.7043 16.367C14.2389 15.9796 14.4525 15.3236 14.2485 14.6957L12.9308 10.6401H12.9486L16.3838 8.13155C16.9156 7.74323 17.1272 7.08775 16.923 6.46173Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49412 0.343295C7.8348 0.345884 7.27869 0.753264 7.07741 1.38115L5.77908 5.43114H1.49702C0.836836 5.43114 0.2789 5.83703 0.0756585 6.46515C-0.127616 7.09326 0.08678 7.74907 0.621875 8.13583L4.07217 10.6297L2.75107 14.6957C2.54706 15.3236 2.76066 15.9796 3.29526 16.367C3.82982 16.7544 4.51979 16.7532 5.05296 16.3638L8.49996 13.8465C8.50003 13.8466 8.50003 0.343262 8.50003 0.343262C8.49807 0.343262 8.49605 0.343262 8.49412 0.343295Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.1b3e80d8d3ab47361c036d6a2b64c897.svg";
export { ForwardRef as ReactComponent };